import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../../components/commonClass/Session';
import { fetchIp, getDateCombination } from '../../../../components/commonClass/CommonFunctions';
import { ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { alphaNumericWithSpace } from '../../../../components/commonClass/CommonValidation';

const HotelCancellation = ({ cancelModelData, setIsCancelModel, setCancellationMessage, setShowCancelMessageModel }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [dropdownData, setDropdownData] = useState<any>({});
    const [formError, setFormError] = useState<any>({})
    const [showPolicy, setShowPolicy] = useState(false)
    const [formValue, setFormValue] = useState<any>({
        CancellationTypeId: 0,
        CancellationImagePath: '',
        CancellationImageName: '',
        Remarks: ''
    })
    const CancellationTypeIdForRemarks = 18;

    const createOptionData = (data: any) => {
        return data.map((obj: any) => ({ label: obj?.ReasonName, value: obj?.ReasonId }));
    }

    const getcancellationreason = async () => {
        dispatch(loaderActions?.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const reason = await getAllData('/customerui/v1/getreasons')
            if (reason?.status) {

                const updatedReasonList = [{ label: 'Select Reason', value: 0 }, ...createOptionData(reason?.data?.cancellationReasonHotelList)];
                setDropdownData({
                    cancellationReasonHotelList: updatedReasonList
                });
                dispatch(loaderActions?.end());
            }
            else {
                dispatch(loaderActions?.end());
            }
        }
        else {
            dispatch(loaderActions?.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const handleSelect = (name: any, value: any) => {
        setFormError({});
        if (name === "CancellationTypeId") {
            let val = JSON.parse(value)
            if (val?.value !== CancellationTypeIdForRemarks && val?.value !== 0) {
                setFormValue((prev: any) => ({
                    ...prev,
                    [name]: val?.value,
                    Remarks: val?.label
                }));
            }
            else {
                setFormValue((prev: any) => ({
                    ...prev,
                    [name]: val?.value,
                    Remarks: ''
                }));
            }
        }
        else {
            setFormValue((prev: any) => ({
                ...prev,
                [name]: value
            }));
        }
    }


    const handleDocUpload = (e: any) => {
        setFormError({});
        const file = e.target.files[0]
        const filecom = getDateCombination();
        let filename = filecom + "_1_" + file?.name;
        setFormValue({
            ...formValue,
            CancellationImageName: filename,
            CancellationImagePath: `UI/Upcoming/flightbooking/${cancelModelData?.localBookingId}/${filename}`,
            Path: `UI/Upcoming/flightbooking/${cancelModelData?.localBookingId}/`,
            type: !(file?.type?.includes('image') || file?.type?.includes('pdf')),
            size: ((file?.size / 1024) / 1024) > 20 ? true : false,
            File: file,
            needToUpload: true
        });
    }

    const handleOnChange = (name: any, value: any) => {
        setFormError({});
        setFormValue((prev: any) => ({
            ...prev,
            [name]: value
        }));
    }

    const validateData = () => {
        let status = true;
        let error: any = {};
        if (formValue?.CancellationTypeId <= 0) {
            error[`CancellationTypeId`] = 'Please select reason.';
            status = false;
        }
        if (formValue?.CancellationImageName?.trim()?.length > 0) {
            if (formValue?.type) {
                error[`CancellationImageName`] = 'Please upload correct image or pdf file.';
                status = false;
            }
            if (formValue?.size) {
                error[`CancellationImageName`] = 'Cannot upload file above 20 MB.';
                status = false;
            }
        }
        if (formValue?.CancellationTypeId === CancellationTypeIdForRemarks) {
            if (formValue?.Remarks?.trim()?.length <= 0) {
                error[`Remarks`] = 'Please provide reason.';
                status = false;
            }
            if (formValue?.Remarks?.trim()?.length > 0 && (formValue?.Remarks?.trim()?.length < 15 || formValue?.Remarks?.trim()?.length > 150)) {
                error[`Remarks`] = 'Character should be between 15 to 150';
                status = false;
            }
        }
        setFormError(error);
        return status;
    }

    const handleApply = () => {
        if (validateData()) {
            setShowPolicy(true);
        }
    }

    const proceedtoCancel = async () => {
        const statusoftoken = await verifytoken();

        if (!statusoftoken) {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            return;
        }

        dispatch(loaderActions.start());

        try {
            const userip = await fetchIp();
            const userData: any = GetLocalStorage();

            const requestPayload = {
                ...formValue,
                BookingMode: 5,
                RequestType: 4,
                BookingId: cancelModelData.TboBookingId,
                // MarkupCharges: cancelModelData?.markupCharges,
                GSTCharges: cancelModelData?.gstCharges,
                ETMFee: cancelModelData?.etmFee,
                CancelCharges: cancelModelData?.cancelCharge,
                ETMRefundAmount: cancelModelData?.refundAmount,
                EndUserIp: userip?.data,
                UserId: userData?.userMasterID,

                IsConvenienceETMPercentage: cancelModelData.isConvenienceETMPercentage,
                ChargeType: cancelModelData?.chargeType,
                CancelllationCharge: cancelModelData?.cancellationCharge,
                ConvenienceFeeETMCharge: cancelModelData?.convenienceFeeETMCharge,
                ConvenienceCharges: cancelModelData?.convenienceFee,
            };
            const res = await postUsersData('/customerui/v1/hotelsendchangerequest', requestPayload);
            if (!res?.status) {
                dispatch({ type: 'ALERTING', message: res?.message || 'Cancellation failed' });
                return;
            }
            sessionStorage.setItem('isCancel', "true")
            setShowCancelMessageModel(res?.data?.message ? true : false);
            setCancellationMessage(res?.data?.message ? res?.data?.message : "");
            setIsCancelModel(false);
            if (requestPayload?.needToUpload) {
                try {
                    const isUpload = await ImageUpload(
                        requestPayload.Path,
                        requestPayload.CancellationImageName,
                        requestPayload.File
                    );

                    if (!isUpload) {
                        console.error('Error While Uploading File!');
                    }
                } catch (uploadError) {
                    console.error('Error While Uploading File:', uploadError);
                }
            }
            // navigate('/hotels');
        } catch (error) {
            console.error('Cancellation Process Error:', error);
            dispatch({ type: 'ALERTING', message: 'Something went wrong. Please try again.' });
        } finally {
            dispatch(loaderActions.end());
        }
    };

    useEffect(() => {
        getcancellationreason();
    }, [])

    return (
        <>
            {!showPolicy && <div className="container cancelBooking ">
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                        <div className="form-floating mb-3">
                            <select
                                className="form-select"
                                id={`CancellationTypeId`}
                                name='CancellationTypeId'
                                value={JSON?.stringify(dropdownData?.cancellationReasonHotelList?.find((el: any) => el.value === formValue?.CancellationTypeId)) || ''}
                                onChange={(e) => handleSelect(e.target.name, e?.target?.value)}
                            >
                                {
                                    dropdownData?.cancellationReasonHotelList?.map((list: any) => {
                                        return (
                                            <option key={`${list?.label}${list?.value}`} value={JSON?.stringify(list)}>{list?.label}</option>
                                        );
                                    })
                                }
                            </select>
                            <label htmlFor={`CancellationTypeId`}>Reason</label>
                            {formError[`CancellationTypeId`] && <div className="text-danger f-14"> {formError[`CancellationTypeId`]} </div>}
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                        <div className="mb-3">
                            <input
                                type="file"
                                className="form-control"
                                id="reasonDocument"
                                placeholder="Type a Reason"
                                accept='.pdf,image/*'
                                onChange={(e) => handleDocUpload(e)}
                            />
                            {formError[`CancellationImageName`] && <div className="text-danger f-14"> {formError[`CancellationImageName`]} </div>}
                        </div>
                    </div>
                    {
                        formValue?.CancellationTypeId === CancellationTypeIdForRemarks &&
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="form-floating mb-3">
                                <textarea
                                    className="form-control feedback"
                                    placeholder="Leave remarks"
                                    id="Remarks"
                                    name='Remarks'
                                    value={formValue?.Remarks}
                                    onChange={(e) => handleOnChange(e.target.name, alphaNumericWithSpace(e.target.value))}
                                    maxLength={150}
                                />
                                <label htmlFor="Remarks">Leave remarks</label>
                                {formError[`Remarks`] && <div className="text-danger f-14"> {formError[`Remarks`]} </div>}
                            </div>
                        </div>
                    }
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                        <button
                            type="button"
                            className="btn sendBtn"
                            disabled={formValue?.CancellationTypeId <= 0 || (formValue?.CancellationTypeId === CancellationTypeIdForRemarks && formValue?.Remarks?.trim()?.length <= 0)}
                            onClick={() => { handleApply() }}
                        ><i className="fa-solid fa-paper-plane"></i> Apply</button>
                    </div>
                </div>
            </div>}


            {showPolicy &&
                <>
                    <div className="modal-body mb-2">
                        {/* <div dangerouslySetInnerHTML={{ __html: rules?.tboResponse?.response?.flightItinerary?.fareRules?.[0]?.fareRuleDetail }}></div> */}
                        <div className='mt-4'>
                            <table className='w-100 cancelletion_table'>
                                <tbody>
                                    <tr>
                                        <th>Paid Amount</th>
                                        <td>
                                            <span className='d-flex align-items-center'>
                                                <img className='me-1' src={require("../../../../assets/img/Rupee-Symbol-Black.png")} style={{ height: '10px' }} alt="logo" />
                                                {cancelModelData?.paidAmount}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Supplier Cancellation charge</th>
                                        <td>
                                            <span className='d-flex align-items-center'>
                                                <img className='me-1' src={require("../../../../assets/img/Rupee-Symbol-Black.png")} style={{ height: '10px' }} alt="logo" />
                                                {cancelModelData?.cancelCharge}
                                            </span>
                                        </td>
                                    </tr>

                                    {!((cancelModelData?.chargeType === "Fixed" && cancelModelData?.cancelCharge === 0) || ((cancelModelData?.cancellationCharge === 100 || cancelModelData?.cancellationCharge === 0) && cancelModelData?.chargeType === "Percentage")) && (
                                        <tr>
                                            <th>ETM Service Fee (Convenience Fee)</th>
                                            <td>
                                                <span className='d-flex align-items-center'>
                                                    <img className='me-1' src={require("../../../../assets/img/Rupee-Symbol-Black.png")} style={{ height: '10px' }} alt="logo" />
                                                    {cancelModelData?.etmFee}
                                                </span>
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <th>Total Refundable Amt</th>
                                        <td>
                                            <span className='d-flex align-items-center'>
                                                <img className='me-1' src={require("../../../../assets/img/Rupee-Symbol-Black.png")} style={{ height: '10px' }} alt="logo" />
                                                {cancelModelData?.refundAmount}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='mt-4 row'>
                                <div className='col-xl-3 col-md-6 col-12 mb-1 mx-auto'>
                                    <button
                                        type="button"
                                        className="btn theme-btn me-1 w-100 cancel_remark"
                                        onClick={() => proceedtoCancel()}
                                    >
                                        Proceed to Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default HotelCancellation